import { Button } from '@mui/material'
import { useWallet, WalletStatus } from '@terra-money/wallet-provider'
import { useModal } from 'react-modal-hook'
import WalletConnectorModal from './Modal/WalletConnectorModal'
import WalletOrangeIcon from 'assets/icons-orange/wallet.svg'
import WalletWhiteIcon from 'assets/icons-white/wallet.svg'
import CloseIcon from 'assets/icons-orange/close.svg'
import styled from '@emotion/styled'
import CoreDivider from 'core/CoreDivider'
import { shortenAddress } from 'utils/display'
import { useEffect, useState } from 'react'
import { useResponsive } from 'hooks/useResponsive'
import { useLocation } from 'react-router-dom'
import RiskAcknowledgeModal from './Modal/RiskAcknowledgeModal'
import { RouteName } from 'constants/constants'

const CustomButton = styled(Button)`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 12px 12px 12px 24px;
  height: 48px;
`

interface Props {
  defaultText?: string
  fullWidth?: boolean
  disabled?: boolean
  anotherWallet?: boolean
  noShowAddress?: boolean
}
const WalletConnector = ({
  defaultText = 'Connect Wallet',
  fullWidth,
  disabled,
  anotherWallet,
  noShowAddress,
}: Props) => {
  const [isConnecting, setIsConnecting] = useState(false)
  const { status, wallets, disconnect } = useWallet()
  const { isMobile } = useResponsive()
  const { pathname } = useLocation()
  const [showDisclaimer, hideDisclaimer] = useModal(() => (
    <RiskAcknowledgeModal
      onClose={hideDisclaimer}
      onProcess={() => {
        hideDisclaimer()
        handleOnConnect()
      }}
    />
  ))

  const [showModal, hideModal] = useModal(() => (
    <WalletConnectorModal onClose={hideModal} />
  ))

  const onDisconnect = () => {
    disconnect()
    hideModal()
  }

  const handleOnConnect = () => {
    setIsConnecting(true)
    showModal()
    setTimeout(() => {
      setIsConnecting(false)
    }, 5000)
  }

  const handleOnClickConnect = () => {
    if (pathname === RouteName.default) showDisclaimer()
    else handleOnConnect()
  }

  useEffect(() => {
    return () => {
      setIsConnecting(false)
    }
  }, [])

  if (
    status === WalletStatus.WALLET_CONNECTED &&
    !anotherWallet &&
    !noShowAddress
  ) {
    const walletAddr = isMobile
      ? shortenAddress(wallets[0].terraAddress, 6, 'end')
      : shortenAddress(wallets[0].terraAddress, 6)
    return (
      <CustomButton variant="outlined" fullWidth={fullWidth}>
        <img src={WalletOrangeIcon} alt="WalletIcon" width={24} height={24} />
        {walletAddr}
        <CoreDivider width="32px" />
        <img
          src={CloseIcon}
          alt="CloseIcon"
          onClick={onDisconnect}
          style={{ cursor: 'pointer' }}
          width={24}
          height={24}
        />
      </CustomButton>
    )
  } else if (
    status === WalletStatus.WALLET_CONNECTED &&
    anotherWallet &&
    !noShowAddress
  ) {
    return (
      <CustomButton
        variant="contained"
        onClick={onDisconnect}
        fullWidth={fullWidth}
        disabled={disabled}
      >
        <img src={WalletWhiteIcon} alt="WalletIcon" width={24} height={24} />
        Connect another wallet
        <div />
      </CustomButton>
    )
  } else {
    return (
      <CustomButton
        variant="contained"
        onClick={handleOnClickConnect}
        fullWidth={fullWidth}
        disabled={disabled}
      >
        <img src={WalletWhiteIcon} alt="WalletIcon" width={24} height={24} />
        {isConnecting ? 'Connecting...' : defaultText}
        <div />
      </CustomButton>
    )
  }
}

export default WalletConnector
